<template>
  <div class="counter" v-if="value">
    {{counter}}

  </div>
</template>

<script>
  export default {
    name: "Counter", 
    props: ["value"],
    data() {
      return {
        counter: 0
      }
    },
  
    watch: {
      value() {
        this.setCounter();
      }
    },

    methods: {
      setCounter() {
        if (this.value < 1000)
          this.counter = this.value;
        else if (this.value < 2000)
          this.counter = "1K+"
        else if (this.value < 3000)
          this.counter = "2K+"
        else if (this.value < 4000)
          this.counter = "3K+"
        else if (this.value < 5000 )
          this.counter = "4K+"
        else if (this.value < 6000)
          this.counter = "5K+"
        else if (this.value < 7000)
          this.counter = "6K+"
        else if (this.value < 8000)
          this.counter = "7K+"
        else if (this.value < 9000)
          this.counter = "8K+"
        else if (this.value < 10000)
          this.counter = "9K+"
        else if (this.value > 10000)
          this.counter ="10K+"
      }
    },
    mounted() {
      this.setCounter();
    }
  }
</script>

<style scoped>

.counter {
  position: relative;
  float: right;
  font-size: 0.5rem;
  font-weight: 500;
  padding: 0.5px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  border-radius: 50%;
  margin-top: -30px;
  margin-right: -14px;
  width: 22px;
  background-color: #ff5f00;
}

</style>